import { PlanningAlgorithm } from '../types/interfaces';

export const PlanningAlgorithmTemplate: PlanningAlgorithm = {
  id: '',
  name: '',
  description: '',
  applyTaskPriority: true,
  validateAttainments: true,
  validateTaskIntervalAndSchedules: true,
  applyEmployeeWorkload: true,
  applyArrivalTimeOptimization: true
};
